import { EventIcon } from "@faire/retailer-visitor-shared/components/Events/shared/EventIcon";
import { useMarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
import Color from "@faire/web--source/slate/Color";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { getEventTheme } from "@faire/web--source/slate/Theme/eventsThemeColors";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import myMarketList from "@faire/web-api--source/routes/www/markets/event_type/all-specials/my-market-list";
import * as React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

interface IProps {
  regularFont?: boolean;
  textColor?: string;
  onClick?: () => void;
}

export const MarketNavElements: React.FC<IProps> = ({
  regularFont,
  textColor,
  onClick,
}) => {
  const { currentEventType } = useMarketStore(["currentEventType"]);

  return (
    <Row align="center">
      <EventIcon size="20px" />
      <Spacer size="1x" />
      <Link
        data-test-id="market-nav-elements-link"
        to={myMarketList(currentEventType)}
        onClick={onClick}
      >
        <StyledTypography
          data-test-id="market-nav-elements-typography"
          variant={regularFont ? "paragraphSansRegular" : "paragraphSansMedium"}
          color={(textColor as Color) ?? getEventTheme("faireMarket").promoText}
          $textColor={
            (textColor as Color) ?? getEventTheme("faireMarket").promoText
          }
        >
          <StrictLocalMsg
            defaultMessage="My market list"
            description={{
              text: "Link to My market list, where retailers can add brands who are participating in the market to a list",
            }}
          />
        </StyledTypography>
      </Link>
    </Row>
  );
};

const StyledTypography = styled(Typography).attrs({
  truncate: true,
})<{ $textColor?: Color }>`
  &:hover,
  &:focus,
  &:focus-within {
    color: ${({ $textColor }) => $textColor};
  }
`;
